import { jwtDecode } from "jwt-decode"; // Named import for jwtDecode

export class StringUtils {
  static capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}

export class AuthUtils {
  static getAuthToken(): string {
    return localStorage.getItem("token") || "";
  }

  static tokenLoader(): boolean {
    return this.getAuthToken() !== "";
  }

  static getAuthUserId(): number | null {
    const token = this.getAuthToken();
    if (!token) return null;

    try {
      const decoded = jwtDecode<{ sub?: number | string }>(token);
      const userId = Number(decoded.sub);
      return Number.isFinite(userId) ? userId : null;
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  }

  static isTokenValid(token: string): boolean {
    try {
      const decoded = jwtDecode<{ exp: number }>(token); // Use named jwtDecode
      const now = Date.now() / 1000; // Current time in seconds
      if(decoded.exp < now){
        localStorage.removeItem('token');
      }
      return decoded.exp > now;
    } catch (error) {
      console.error("Invalid token:", error);
      return false;
    }
  }
}
